import { Models } from '../../models/models';
import * as T_T from 'cryface';

export abstract class DataDelegate {
    private _name: string;
    public get Name() {
        return this._name;
    }

    private _data: any = [];

    private _resources: any[] = [];

    public get Data() {
        return this._data;
    }
    public set Data(data: any) {
        this._data = data;
    }

    constructor(name: string) {
        this._name = name;
    }

    public getResourceByKey(key: string): any {
        const resource: Models.IKeyValue<any> = this._resources.find((element: Models.IKeyValue<any>) => {
            return element.key === key;
        });
        if (!T_T.simpleDetect(resource)) {
            return undefined;
        }
        return resource.value;
    }

    public addResource(key: string, value: any) {
        const newRes: Models.IKeyValue<any> = {
            key: key, value: value
        };
        this._resources.push(newRes);
    }

    public delResource(key: string) {
        const resource: Models.IKeyValue<any> = this._resources.find((element: Models.IKeyValue<any>) => {
            return element.key === key;
        });
        if (!T_T.simpleDetect(resource)) {
        } else {
            this._resources.splice(this._resources.indexOf(resource), 1);
        }
    }

    public clearResources() {
        this._resources = [];
    }

    public getResources() {
        return this._resources;
    }

    public clearData() {
        this._data = [];
    }
}
